module.exports = __webpack_public_path__ + "static/media/Ferry Captain.89633760.jpg";